import { useLayoutEffect, useRef, type ReactNode } from 'react';

/**
 * Keeps what it holds at the tallest it has been (the owner, 29.09.2026: nothing may change its
 * height when an option changes - whose net worth, the kind of a new entry). The content stretches
 * to that height, so a shorter choice leaves room at its bottom instead of pulling the page up. A
 * new width (another window size, a turned phone) starts again from the content's own height.
 */
export function StableHeight({ children, className }: { children: ReactNode; className?: string }) {
  const box = useRef<HTMLDivElement>(null);
  useLayoutEffect(() => {
    const element = box.current;
    if (!element || typeof ResizeObserver === 'undefined') return;
    let width = -1;
    let tallest = 0;
    const observer = new ResizeObserver(([entry]) => {
      const now = Math.round(entry!.contentRect.width);
      if (now !== width) {
        width = now;
        tallest = 0;
        element.style.minHeight = '';
      }
      // With the floor set the box never measures below it, so this only ever grows.
      const height = element.offsetHeight;
      if (height > tallest) {
        tallest = height;
        element.style.minHeight = `${height}px`;
      }
    });
    observer.observe(element);
    return () => observer.disconnect();
  }, []);
  return (
    <div ref={box} className={['stable-height', className].filter(Boolean).join(' ')}>
      {children}
    </div>
  );
}
